/**
 * `/c/:symbol/gaps` — a shareable URL for the Gaps tab.
 *
 * The content itself is a tab panel on the company screen, like every other
 * company view: a tab bar where one entry navigates away and the rest switch
 * panels reads as a bug. But "send someone the gaps for 3002" wants a URL
 * that says so rather than a query parameter, so this route exists and
 * redirects to the canonical one.
 *
 * Outside the superadmin view it redirects to the company instead. The tab
 * is hidden there, and a bookmark that reached the panel anyway would be a
 * hole straight through the one thing this mode is for.
 */
import { Redirect, useParams } from 'wouter'
import { useSuperadmin } from '~/lib/superadmin.ts'

export function GapsScreen() {
  const { symbol = '' } = useParams<{ symbol: string }>()
  const superadmin = useSuperadmin()
  return <Redirect to={`/c/${symbol}${superadmin ? '?tab=gaps' : ''}`} replace />
}
